import { $ } from '../util/DOM';

const closeSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.001 512.001" width="50" height="50"><path d="M284.286 256.002L506.143 34.144c7.811-7.811 7.811-20.475 0-28.285-7.811-7.81-20.475-7.811-28.285 0L256 227.717 34.143 5.859c-7.811-7.811-20.475-7.811-28.285 0-7.81 7.811-7.811 20.475 0 28.285l221.857 221.857L5.858 477.859c-7.811 7.811-7.811 20.475 0 28.285a19.938 19.938 0 0014.143 5.857 19.94 19.94 0 0014.143-5.857L256 284.287l221.857 221.857c3.905 3.905 9.024 5.857 14.143 5.857s10.237-1.952 14.143-5.857c7.811-7.811 7.811-20.475 0-28.285L284.286 256.002z"/></svg>';

const createModal = (content, keepInDoc) => {

  const container = $.render('div', {
    className: 'modal',
    innerHTML: /* html */ `<div class="modal-content">${
      (content && content.outerHTML) || content || ''
    }<button type="button" class="close">${closeSVG}</button></div>`,
  });

  document.body.appendChild(container);

  const stopAllYouTubeVideos = () => {
    const iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      if (iframe) {
        const iframeSrc = iframe.src;
        // eslint-disable-next-line no-param-reassign
        iframe.src = iframeSrc;
      }
    });
  };

  const open = () => {
    container.classList.add('open');
    document.body.classList.add('has-modal');
  };

  let fechar = document.querySelectorAll('.close').forEach(item =>{
      item.addEventListener('click', (keep = keepInDoc)=>{
      container.classList.remove('open');
      document.body.classList.remove('has-modal');
      stopAllYouTubeVideos();
      if (!keep) {
        setTimeout(() => {
          container.remove();
        }, 500);
      }
    })
  })

const close = (keep = keepInDoc) => {
  container.classList.remove('open');
  document.body.classList.remove('has-modal');
  if (!keep) {
    setTimeout(() => {
      container.remove();
    }, 500);
  }
};

  document.body.appendChild(container);

  const modal = {
    container,
    open,
    close,
  };

  container.modal = modal;

  return modal;
};

export default createModal;
